import React from "react"
import { connect } from "react-redux"

import {
    addFeedApplyModelUpdate,
    addFeedCancelModelUpdate,
    addFeedModerate,
    addFeedToggleRejectionReasonModal
} from "../../../actions/add-feed-actions"
import EditFeedFormActionButtonsWidget from "../knowledge-item/edit/EditFeedFormActionButtonsWidget"
import AddFeedRejectionReasonModalContainer from "./AddFeedRejectionReasonModalContainer"

// The feed page's rejection modal would reject whichever item the feed page has open, so use the Add flow's own
const AddFeedFormActionButtonsWidget = props => (
    <EditFeedFormActionButtonsWidget
        {...props}
        RejectionReasonModal={AddFeedRejectionReasonModalContainer}
    />
)

const mapStateToProps = ({ presentation: { addFeed } }, props) => ({
    moderationStatus: addFeed.workingModel.approved,
    canSave: addFeed.canSave,
    canEdit: true,
    // The item is saved as soon as it's added, so Save is only for changes made here afterwards
    saveDisabledTitle: addFeed.isEditMode ? "No changes to save" : undefined,
    canCancel: addFeed.canCancel,
    showModerationButtons: addFeed.isEditMode,
    showCancel: addFeed.isEditMode,
    isCreateMode: false,
    isSaving: addFeed.isSavingItem,
    isRejectReasonModalOpen: addFeed.isRejectReasonModalOpen,
    suggestedModerationStatus: addFeed.workingModel.approval_suggestion,
    header: `Link Classification${
        !addFeed.isEditMode ? " Preview" : ""
    }`,
    ...props
})

const mapDispatchToProps = dispatch => ({
    cancel: () => dispatch(addFeedCancelModelUpdate()),
    save: () => dispatch(addFeedApplyModelUpdate()),
    approve: () => dispatch(addFeedModerate(true)),
    reject: () => dispatch(addFeedToggleRejectionReasonModal()),
    unmoderate: () => dispatch(addFeedModerate(null))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddFeedFormActionButtonsWidget)
